var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { debounce, isEqual } from "lodash-es";
import { load, dump } from 'js-yaml';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import 'codemirror/mode/yaml/yaml';
import 'codemirror/addon/display/placeholder';
import "./index.css";
import getTypeIcon from '../../../assets/typeIcons';
import 'codemirror/theme/monokai.css';
import 'codemirror/theme/zenburn.css';
import { InlineCodeMirrorBase } from "../../../../lib/comps/InlineCodeMirrorBase";
import { vueLinkLocalStorage } from "../../../../lib/utils/vue";
import { ICMBTButton } from "../../../../lib/comps/InlineCodeMirrorBase/ICMBTButton";
const allCastModes = ['yaml', 'json'];
let AnyInputText = class AnyInputText extends InlineCodeMirrorBase {
  get cmOptions() {
    return {
      mode: 'yaml',
      ...this.owner.propCmOptions
    };
  }
  get logo() {
    const h = this.$createElement;
    const {
      valueType
    } = this.owner;
    if (!valueType) return null;
    return h("img", {
      "attrs": {
        "src": valueType.icon,
        "title": valueType.title
      },
      "class": "ucd-anyInput-icon"
    });
  }
  get toolbar() {
    const h = this.$createElement;
    const ans = [];
    const {
      owner
    } = this;
    // AnyInput 没有强行指定语法的时候，显示语法切换按钮
    if (!owner.castMode) {
      const {
        preferCastMode
      } = owner;
      ans.push(h(ICMBTButton, {
        "attrs": {
          "icon": "percent",
          "title": "切换语法(不影响数据)"
        },
        "on": {
          "click": () => {
            owner.preferCastMode = allCastModes[(allCastModes.indexOf(preferCastMode) + 1) % allCastModes.length];
          }
        }
      }, [preferCastMode]));
    }
    return ans;
  }
  onBlur() {
    this.owner.handleBlur();
  }
  onCmReady(cm) {
    this.owner.handleCmReady(cm);
  }
  handleMouseEnter() {
    var _this$cm;
    // 避免样式问题，首次渲染要 refresh
    if (this.cmRefreshed) return;
    (_this$cm = this.cm) === null || _this$cm === void 0 || _this$cm.refresh();
    this.cmRefreshed = true;
  }
  render() {
    const h = arguments[0];
    const baseClass = this.getInlineCodeMirrorBaseClassName();
    const {
      owner
    } = this;
    return h("div", {
      "class": mergeClassName(baseClass, 'ucd-anyInput', !!(owner.tempResult.error || owner.hasError) && 'hasError'),
      "on": {
        "mouseenter": this.handleMouseEnter
      }
    }, [this.logo, this.renderInlineCodeMirrorBase()]);
  }
};
__decorate([Prop({})], AnyInputText.prototype, "owner", void 0);
AnyInputText = __decorate([Component({
  name: 'AnyInputText'
})], AnyInputText);
let AnyInput = class AnyInput extends Vue {
  constructor() {
    super(...arguments);
    this.editStr = '';
    // 这个是非实时的。要获取实时的，请调用 getResult()
    this.tempResult = {};
    this.preferCastMode = 'json';
  }
  getResult() {
    // 空字符串标示 undefined
    if (!this.editStr) return {
      value: void 0
    };
    try {
      let str = this.editStr;
      if (this.finalCastMode === 'json') {
        str = this.editStr.replace(/('[^']*'|"[^"]*")|(^|{|,)\s*\w+:(?=\S)/gm, (s, k) => k || `${s} `);
      }
      return {
        value: load(str)
      };
    } catch (error) {
      return {
        error
      };
    }
  }
  get finalCastMode() {
    if (this.castMode) return this.castMode;
    return this.preferCastMode;
  }
  focus() {
    var _this$editor;
    (_this$editor = this.editor) === null || _this$editor === void 0 || _this$editor.focus();
  }
  reset(force = false) {
    if (!force) {
      const v = this.getResult();
      if (!v.error && isEqual(v.value, this.value)) return; // nothing to reset
    }
    if (this.value === void 0) {
      this.editStr = '';
    } else {
      const yamlString = dump(this.value, {
        quotingType: '"',
        forceQuotes: true
      }).replace(/\s+$/, '');
      this.editStr = this.finalCastMode === 'yaml' ? yamlString : JSON.stringify(this.value, null, 2);
    }
    // this.editStr = dump(this.value, {
    //   flowLevel: 0,
    //   quotingType: '"',
    //   forceQuotes: true,
    // }).replace(/\s+$/, '');
    this.syncTempResultDebounced.cancel();
    this.tempResult = {
      value: this.value
    };
  }
  syncTempResult() {
    this.tempResult = this.getResult();
  }
  created() {
    this.syncTempResultDebounced = debounce(() => this.syncTempResult(), 500);
    this.commitDebounced = debounce(() => {
      this.syncTempResultDebounced.cancel();
      this.syncTempResult();
      if (!this.tempResult.error && !isEqual(this.tempResult.value, this.value)) {
        this.$emit('change', this.tempResult.value);
      }
    }, 300, {
      trailing: true,
      leading: true
    });
    this.$watch(() => this.value, () => this.reset(), {
      immediate: true,
      deep: true
    });
    this.$watch(() => this.finalCastMode, () => this.reset(true));
    vueLinkLocalStorage(this, 'anyInput', 'preferCastMode');
  }
  beforeDestroy() {
    this.syncTempResultDebounced.cancel();
    this.commitDebounced.flush();
  }
  handleInput(val) {
    this.editStr = val;
    if (this.inputSync) {
      this.commitDebounced();
    } else {
      this.syncTempResultDebounced();
    }
  }
  handleBlur() {
    if (!this.inputSync) {
      this.commitDebounced();
      this.commitDebounced.flush();
      if (!this.tempResult.error) {
        const yamlString = dump(this.value, {
          quotingType: '"',
          forceQuotes: true
        }).replace(/\s+$/, '');
        this.editStr = this.finalCastMode === 'yaml' ? yamlString : JSON.stringify(this.value, null, 2);
      }
    } else {
      this.$emit('blur');
    }
  }
  handleCmReady(cm) {
    // 错误提示
    let lastErrorLineHandle;
    let lastMarker;
    let lastLineWidget;
    // 自动添加错误 marker
    this.$watch(() => {
      const error = this.tempResult.error;
      if (!error || !('mark' in error)) return null;
      return error.mark;
    }, mark => {
      if (lastMarker) lastMarker.clear();
      if (lastErrorLineHandle) cm.removeLineClass(lastErrorLineHandle, 'background', 'ucd-anyInput-errorLine');
      if (lastLineWidget) lastLineWidget.clear();
      lastMarker = undefined;
      lastErrorLineHandle = undefined;
      lastLineWidget = undefined;
      // ----------------
      if (!mark) return;
      lastMarker = cm.markText({
        line: mark.line,
        ch: mark.column
      }, {
        line: mark.line + 1,
        ch: 0
      }, {
        css: 'background: #f99'
      });
      lastErrorLineHandle = cm.getLineHandle(mark.line);
      if (lastErrorLineHandle) {
        var _this$tempResult$erro;
        cm.addLineClass(lastErrorLineHandle, 'background', 'ucd-anyInput-errorLine');
        const errorMessage = document.createElement('div');
        errorMessage.className = 'ucd-anyInput-errorMessage';
        errorMessage.textContent = String((_this$tempResult$erro = this.tempResult.error) === null || _this$tempResult$erro === void 0 ? void 0 : _this$tempResult$erro.message).replace(/ at line[\d\D]+$/, '');
        lastLineWidget = cm.addLineWidget(lastErrorLineHandle, errorMessage);
      }
    }, {
      immediate: true
    });
    // 最后抛出事件
    this.$emit('ready', this);
  }
  get valueType() {
    const {
      value,
      error
    } = this.tempResult;
    if (error) {
      return {
        icon: getTypeIcon('error'),
        title: `请输入有效的 JSON 或者 YAML\n\n${error}`
      };
    }
    if (this.hideIcon) return null;
    const typeName = Array.isArray(value) ? 'array' : typeof value;
    let title = `数据类型：${typeName}`;
    if (typeName !== 'string') title += '\n\n如果要 string，请在前后加上双引号';
    return {
      icon: getTypeIcon(typeName),
      title
    };
  }
  render() {
    const h = arguments[0];
    return h(AnyInputText, {
      "ref": "editor",
      "attrs": {
        "owner": this,
        "value": this.editStr,
        "readonly": this.readonly
      },
      "on": {
        "change": this.handleInput
      }
    });
  }
};
__decorate([Prop({})], AnyInput.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AnyInput.prototype, "readonly", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], AnyInput.prototype, "placeholder", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AnyInput.prototype, "hideIcon", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], AnyInput.prototype, "castMode", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], AnyInput.prototype, "inputSync", void 0);
__decorate([Prop({
  type: Object,
  default: null
})], AnyInput.prototype, "propCmOptions", void 0);
__decorate([Ref()], AnyInput.prototype, "editor", void 0);
AnyInput = __decorate([Component({
  name: 'AnyInput',
  model: {
    prop: 'value',
    event: 'change'
  }
})], AnyInput);
export default AnyInput;
//# sourceMappingURL=index.js.map
